<template>
    <UTooltip
        v-if="isTruncated"
        class="select-none"
        :ui="{ base: '!h-auto whitespace-normal break-words max-w-xs text-left' }"
    >
        <span>{{ truncated }}</span>
        <template #text>{{ value }}</template>
    </UTooltip>
    <span v-else>{{ value }}</span>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
    value: string
    limit?: number
}>(), {
    limit: 30,
})

const isTruncated = computed(() => (props.value?.length || 0) > props.limit)
const truncated = computed(() => isTruncated.value
    ? props.value.slice(0, props.limit).trimEnd() + '…'
    : props.value
)
</script>
